import styled from 'styled-components';
import { IonPage } from '@ionic/react';

export const IonPageWrapper = styled(IonPage)`
  .overlay {
    position: absolute;
    background-color: blue;
    width: 100vw;
    height: 100vh;
    z-index: 1000;

    &.hidden {
      opacity: 0;
    }
  }
`;